import { createContext, useContext } from "react";
import { useQuery, } from "@tanstack/react-query";
import { getApplications } from "../../api/applications";
import Const from "../../utils/constant";

const PageContext = createContext();

const initialValues = {
  Banner: { heading: "", subheading: "", cta: "", ctaRedirectLink: "" },
};

export const PageProvider = ({ children }) => {
  const getBlogsQuery = useQuery({
    queryKey: ["blogs"],
    queryFn: getApplications,
  });

  const handleDownAssementFile = (url) => {
    window.open(Const.getS3File(url), "_blank");
  };

  const handleDownResumeFile = (url) => {
    window.open(Const.getS3File(url), "_blank");
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        getBlogsQuery,
        handleDownAssementFile,
        handleDownResumeFile,
      }}>
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
